import React, { useContext, useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useWizard } from 'react-use-wizard';
import { PaymentContext } from '../../pages/billing/PaymentContext';
import routes from '../../routes/constants';
import text from '../../text';
import Button from '../button/Button';
import BottomContainer from '../containers/BottomContainer';
import T from 'prop-types';
import { getStepNameByIndex } from '../../pages/billing/OrderWizard/orderStepsFactory';
import { isRouteIncluded } from '../../utilities/routes';
import { useUpdateOrderProgressMutation } from '../../redux/rtk';
import useUser from '../../mp/hooks/useUser';

const StepFooter = (props) => {
  const { jobId } = useParams();
  const history = useHistory();
  const { previousStep, nextStep, isFirstStep, activeStep } = useWizard();
  const { previousButtonProps = {}, nextButtonProps = {}, topContent } = props;
  const {
    onClick: onClickPreviousButton,
    label,
    ...restPreviousButtonProps
  } = previousButtonProps;

  const { actions } = useContext(PaymentContext);
  const [updateOrderProgress] = useUpdateOrderProgressMutation();
  const { isEssentialUser, isGovernment } = useUser();

  useEffect(() => {
    actions.handleSetWizardStep(activeStep);
  }, [actions, activeStep]);

  const onCancel = () => {
    history.push(routes.home);
  };

  const location = useLocation();
  const isPaymentFlow = isRouteIncluded([routes.mp.payment()])(
    location.pathname
  );

  useEffect(() => {
    // only update job order progress when in payment flow
    if (isPaymentFlow && jobId) {
      updateOrderProgress({
        jobId,
        orderProgress: getStepNameByIndex(
          activeStep,
          isEssentialUser || isGovernment
        ),
      });
    }
  }, [
    activeStep,
    isPaymentFlow,
    jobId,
    updateOrderProgress,
    isEssentialUser,
    isGovernment,
  ]);

  return (
    <BottomContainer className='StepFooter'>
      <div className='top'>{topContent}</div>
      <div className='bottom'>
        <div className='left'>
          <Button variant='link' onClick={onCancel}>
            {text('cancel')}
          </Button>
        </div>
        <div className='right'>
          {!isFirstStep && (
            <Button
              variant='outline-primary'
              onClick={
                onClickPreviousButton
                  ? () => onClickPreviousButton(previousStep)
                  : previousStep
              }
              {...restPreviousButtonProps}
            >
              {label || text('previous')}
            </Button>
          )}
          <Button
            className='ml-3 full-width'
            onClick={
              nextButtonProps?.onClick
                ? () => nextButtonProps.onClick(nextStep)
                : nextStep
            }
            loading={nextButtonProps.loading || false}
            disabled={nextButtonProps.disabled}
          >
            {nextButtonProps.label || text('next')}
          </Button>
        </div>
      </div>
    </BottomContainer>
  );
};

StepFooter.propTypes = {
  previousButtonProps: T.object,
  nextButtonProps: T.object,
  topContent: T.object,
};

export default StepFooter;
